module.exports = __webpack_public_path__ + "media/images/emblems/Ferden-f8062aa1619d66fa30951bbfe735e84b.png";